var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1132,
    height: 421,
    viewBox: "0 0 1132 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.986 266.548L132.673 255.733C132.64 254.566 132.376 253.418 131.898 252.353C131.42 251.288 130.737 250.327 129.887 249.526C129.037 248.726 128.038 248.1 126.947 247.685C125.855 247.271 124.692 247.075 123.525 247.11L28.8691 249.914C26.5098 249.983 24.2747 250.986 22.6553 252.702C21.036 254.419 20.1651 256.708 20.2342 259.067L25.7741 450.176L270.62 442.927L265.677 272.308C265.64 271.036 265.352 269.784 264.83 268.623C264.309 267.462 263.563 266.416 262.637 265.543C261.711 264.67 260.621 263.989 259.431 263.537C258.241 263.085 256.974 262.872 255.701 262.91L132.986 266.548Z",
    fill: "#F0B429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.033 266.86L35.617 274.099L25.7159 448.271L269.367 441.058L280.033 266.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7 288.876L62.0621 295.617L25.7158 448.271L269.367 441.058L289.7 288.876Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.405 226.299C255.74 252.939 247.403 311.64 247.403 311.64L136.602 314.919C142.693 271.065 169.023 207.13 169.023 207.13L270.405 226.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.412 241.735L169.471 224.845L171.256 219.552L258.802 236.511L257.412 241.735Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.699 255.653L164.702 238.947L166.531 233.537L255.119 250.318L253.699 255.653Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.908 269.864L159.835 253.355L161.703 247.828L251.362 264.416L249.908 269.864Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.402 278.728L154.857 268.086L156.769 262.436L216.029 273.13L214.402 278.728Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.297 281.16L190.987 283.914L135.646 315.755L51.8125 318.248C49.6698 318.31 47.6185 319.129 46.0223 320.559C44.4262 321.99 43.3885 323.939 43.0933 326.062L25.7739 450.176L270.62 442.927L291.776 291.302C292.473 286.322 288.601 281.917 283.297 281.16Z",
    fill: "#FCE588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.837 242.689L960.524 231.879C960.49 230.712 960.227 229.563 959.749 228.498C959.271 227.432 958.587 226.472 957.738 225.671C956.888 224.869 955.889 224.243 954.798 223.828C953.706 223.413 952.544 223.217 951.376 223.251L856.747 226.058C854.388 226.128 852.154 227.131 850.535 228.848C848.916 230.564 848.044 232.852 848.112 235.211L853.647 426.324L1098.49 419.07L1093.54 248.171C1093.46 245.683 1092.4 243.329 1090.58 241.623C1088.77 239.917 1086.36 238.998 1083.87 239.066L960.837 242.689Z",
    fill: "#F0B429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.98 245.974L831.888 253.082L857.73 426.497L1097.28 419.104L1071.98 245.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.157 285.153C891.391 293.61 838.952 301.436 838.952 301.436C838.952 301.436 833.433 256.46 794.948 185.3L910.433 159.732C910.433 159.732 932.574 199.424 943.088 251.458C945.355 262.595 947.046 273.842 948.157 285.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.535 185.863L818.743 197.028L820.192 201.176L869.376 189.92C868.737 188.583 868.123 187.23 867.535 185.863Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.588 193.35L824.583 213.715L823.129 209.571L912.135 189.202L913.588 193.35Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.975 205.889L828.969 226.253L827.52 222.109L916.526 201.741L917.975 205.889Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.365 218.428L833.36 238.796L831.907 234.648L920.916 214.28L922.365 218.428Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.756 230.967L837.746 251.335L836.297 247.187L925.303 226.818L926.756 230.967Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.142 243.505L842.137 263.874L840.684 259.725L929.689 239.357L931.142 243.505Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.533 256.044L846.523 276.412L845.074 272.264L934.079 251.9L935.533 256.044Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.75 243.41L956.447 246.142L912.999 281.195L821.519 283.908L854.77 429.419L1099.62 422.166L1061.34 254.652C1060.07 249.147 1054.42 244.268 1048.75 243.41Z",
    fill: "#FCE588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 154.823C597.054 154.823 575.105 180.16 527.411 184.555C493.297 187.698 476.419 160.089 476.419 160.089L381.317 206.547C381.317 206.547 393.485 233.188 432.314 231.014C480.135 228.336 501.957 201.277 501.957 201.277L597.054 154.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.076 216.962L580.237 168.647C580.237 168.647 593.862 160.63 597.174 154.745C589.531 158.511 499.658 197.056 499.658 197.056C499.658 197.056 495.45 209.245 482.076 216.962Z",
    fill: "#F7C948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.235 140.973L700.806 117.352C703.898 114.677 707.141 112.182 710.519 109.878C697.917 107.158 682.205 106.537 663.849 110.553C627.658 118.932 603.235 140.973 603.235 140.973Z",
    fill: "#F7C948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.142 111.429C658.719 111.783 657.28 112.165 655.825 112.576L660.142 111.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.519 109.878C713.609 110.541 716.661 111.369 719.663 112.358C716.752 111.308 713.785 110.422 710.776 109.702L710.519 109.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.664 78.3741C772.358 79.7012 686.03 105.615 660.146 111.429C707.272 97.6229 747.196 120.432 763.962 147.371L886.024 117.915C886.024 117.915 858.583 77.7689 808.664 78.3741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.688 107.387C680.986 107.51 672.323 108.571 663.849 110.553C682.206 106.519 697.917 107.158 710.519 109.878L710.776 109.702C703.869 108.061 696.786 107.283 689.688 107.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.797 175.44L280.624 197.289C290.262 186.181 310.413 175.71 321.345 174.016C289.887 151.751 225.949 137.667 192.797 175.44Z",
    fill: "#F7C948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.759 165.365C203.759 165.365 238.834 140.484 303.567 133.039C353.538 127.293 382.028 134.17 413.425 148.671C398.988 158.098 330.468 191.327 331.622 190.895C331.622 190.895 262.777 126.94 203.759 165.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.147 126.019L760.608 131.569L870.041 104.784L865.336 101.16L755.147 126.019Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.38 115.094L745.885 119.049L855.255 93.7637L848.568 90.2355L738.38 115.094Z",
    fill: "#D9F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.243 106.464L723.283 108.714L830.925 83.8301L821.836 81.6938L712.243 106.464Z",
    fill: "#D9F1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090.43,
    height: 449.964,
    fill: "white",
    transform: "translate(46.6001) rotate(5.82795)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5d9149b362c2b70d2fa754be2008244a.svg";
export { ForwardRef as ReactComponent };